export class ManagedCredentialMaterialWriteError extends Error {
  constructor(
    message: string = "managed credentials are owned by the control plane; use the Connected apps page to create or modify them.",
  ) {
    super(message);
    this.name = "ManagedCredentialMaterialWriteError";
  }
}
